module.exports = __webpack_public_path__ + "img/weiqu.567e57bc.jpg";